let elements = {
  /**direction type:
  auto
  top
  bottom
  left
  right
  topleft
  topright
  bottomleft
  bottomright
  lefttop
  leftbottom
  righttop
  rightbottom
  **/

  mainImage: {
    imagePath: 'games/page051_game10/img/bcg3.jpg',
    width: 1770,
    height: 891,
    pos: {
      x: 60,
      y: 173,
    },
  },
  activeArea: {
    width: 50,
    height: 50,
    fontSize: 35,
    backgroundColor: '#f36f1a',
    color: '#ffffff',
  },
  items: [
    {
      id: '8',
      animation: true,
      // direction: 'left',
      textObj: {
        text: 'Kliknij w kategorię <i>Dźwięk</i>.',
      },
      audio: {
        src: 'games/page051_game10/audio/z25s51-8.mp3',
        // icon: {
        //   audioOn: 'assets/on.png',
        //   audioOff: 'assets/off.png',
        // },
        // position: 'top',
      },
      pos: {
        x: 143,
        y: 513,
      },
    },
    {
      id: '9',
      // direction: 'left',
      textObj: {
        text: 'Przeciągnij bloczek <i>Zagraj dźwięk Miau</i>.',
      },
      audio: {
        src: 'games/page051_game10/audio/z25s51-9.mp3',
        // icon: {
        //   audioOn: 'assets/on.png',
        //   audioOff: 'assets/off.png',
        // },
        // position: 'top',
      },
      pos: {
        x: 919,
        y: 710,
      },
    },
    {
      id: '10',
      // direction: 'left',
      textObj: {
        text: 'Kliknij w okienko z&nbsp;zieloną flagą, aby&nbsp;uruchomić program.',
      },
      audio: {
        src: 'games/page051_game10/audio/z25s51-10.mp3',
        // icon: {
        //   audioOn: 'assets/on.png',
        //   audioOff: 'assets/off.png',
        // },
        // position: 'top',
      },
      pos: {
        x: 1132,
        y: 320,
      },
    },
    {
      id: '11',
      // direction: 'left',
      textObj: {
        text: 'Zobacz, co robi duszek-kot.',
      },
      audio: {
        src: 'games/page051_game10/audio/z25s51-11.mp3',
        // icon: {
        //   audioOn: 'assets/on.png',
        //   audioOff: 'assets/off.png',
        // },
        // position: 'top',
      },
      pos: {
        x: 1615,
        y: 638,
      },
    },
  ],
};
export default elements;
